// src/views/admin/ADAbonnements.jsx
//
// PERMISSIONS (module "abonnements") :
// - abonnements.voir        : accès à la page (déjà géré au niveau sidebar / route)
// - abonnements.attribuer   : bouton "Attribuer" (onglet Élèves)
// - abonnements.renouveler  : bouton "Renouveler" (onglets Élèves + Abonnements)
// - abonnements.resilier    : bouton "Résilier" (onglets Élèves + Abonnements)
// Tous les onglets sont visibles pour qui a accès à la page.

import { useState, useEffect } from "react";
import { useAdminService } from "../../services/adminService";
import { Loader } from "../../components/Loader";
import { useToastHook } from "../../utils/useToast";
import { usePermissions } from "../../context/PermissionsContext";

function Modal({ title, onClose, children, maxWidth = 450 }) {
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" style={{ maxWidth }}>
        <div className="modal-title">
          {title}
          <button className="ibtn" style={{ border: "none" }} onClick={onClose}>
            <i className="ti ti-x" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

const NOTIF_LABELS = {
  sms: "SMS",
  email: "Email",
  push: "Notification push",
  tous: "Tous les canaux",
};

const POINTAGE_LABELS = {
  entree: "Entrée uniquement",
  sortie: "Sortie uniquement",
  les_deux: "Entrée et sortie",
};

const STATUT_NOTIF_LABELS = {
  tous: "Tous les statuts",
  present: "Présence à l'heure",
  retard: "Retard uniquement",
  absent: "Absence uniquement",
};

const STATUT_NOTIF_META = {
  tous: { color: "var(--m)", icon: "ti-bell" },
  present: { color: "#198754", icon: "ti-circle-check" },
  retard: { color: "#ffc107", icon: "ti-clock-hour-3" },
  absent: { color: "#dc3545", icon: "ti-alert-triangle" },
};

function formatMoney(v) {
  if (v == null) return "—";
  return `${Number(v).toLocaleString("fr-FR")} FCFA`;
}
function formatDate(d) {
  if (!d) return "—";
  try { return new Date(d).toLocaleDateString("fr-FR"); } catch { return d; }
}
function formatMois(m) {
  if (!m) return "—";
  try {
    const [y, mo] = m.split("-");
    return new Date(Number(y), Number(mo) - 1, 1).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
  } catch { return m; }
}

function OffreBadges({ offre }) {
  if (!offre) return null;
  const statutMeta = STATUT_NOTIF_META[offre.statut_notification] || STATUT_NOTIF_META.tous;
  return (
    <div className="offre-tags">
      <span className="pill info"><i className="ti ti-bell" />{NOTIF_LABELS[offre.type_notification] || offre.type_notification}</span>
      <span className="pill neu"><i className="ti ti-login" />{POINTAGE_LABELS[offre.pointage_notification] || offre.pointage_notification}</span>
      <span className="pill" style={{ background: `${statutMeta.color}1a`, color: statutMeta.color }}>
        <i className={`ti ${statutMeta.icon}`} />{STATUT_NOTIF_LABELS[offre.statut_notification] || offre.statut_notification}
      </span>
    </div>
  );
}

// Onglets de la page (tous visibles pour qui a accès à la page).
const ONGLETS = [
  { key: "eleves", label: "ÉLÈVES", icon: "ti-users" },
  { key: "abonnements", label: "ABONNEMENTS", icon: "ti-crown" },
  { key: "historique", label: "HISTORIQUE PAIEMENTS", icon: "ti-history" },
  { key: "finances", label: "FINANCES", icon: "ti-chart-histogram" },
];


export default function ADAbonnements({ slug }) {
  const [activeTab, setActiveTab] = useState("eleves");

  return (
    <div>
      <div className="tab-nav">
        {ONGLETS.map(({ key, label, icon }) => (
          <button
            key={key}
            className={`tab-btn ${activeTab === key ? "active" : ""}`}
            onClick={() => setActiveTab(key)}
          >
            <i className={`ti ${icon}`} /> {label}
          </button>
        ))}
      </div>

      {activeTab === "eleves" && <ElevesPanel slug={slug} />}
      {activeTab === "abonnements" && <AbonnementsPanel slug={slug} />}
      {activeTab === "historique" && <HistoriquePaiementsPanel slug={slug} />}
      {activeTab === "finances" && <FinancesPanel slug={slug} />}

      <style>{`
/* ─── ONGLETS (thème bleu + or) ─── */
.tab-nav {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  background: linear-gradient(180deg, var(--pr-dk) 0%, var(--pr) 100%);
  border-radius: 10px;
  border-bottom: 3px solid var(--or);
  padding: 8px 12px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.tab-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background: transparent;
  color: rgba(255,255,255,0.75);
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.tab-btn i { font-size: 18px; }

.tab-btn:hover {
  background: rgba(255,255,255,0.12);
  color: var(--or-lt);
}

.tab-btn.active {
  background: white;
  color: var(--pr);
  box-shadow: inset 0 -3px 0 var(--or), 0 2px 8px rgba(0,0,0,0.15);
}
.tab-btn.active i { color: var(--or); }
.tab-btn.active:hover { background: white; color: var(--pr); }
        .card {
          background: var(--s); border: 0.5px solid var(--b);
          border-radius: var(--radius-md); padding: 14px;
        }

        .toolbar { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 12px; align-items: center; }
        .toolbar input[type="text"], .toolbar select, .toolbar input[type="date"] {
          padding: 8px 12px; border: 0.5px solid var(--b2); border-radius: 5px;
          font-size: 14px; background: var(--s); color: var(--t); font-family: inherit;
        }

        .offre-tags { display: flex; gap: 6px; flex-wrap: wrap; }

        .pill {
          display: inline-flex; align-items: center; gap: 4px;
          padding: 4px 9px; border-radius: 9px; font-size: 12px; font-weight: 600;
        }
        .pill.ok  { background: var(--gn-bg); color: var(--gn); }
        .pill.warn{ background: var(--am-bg); color: var(--am); }
        .pill.rd  { background: var(--rd-bg); color: var(--rd); }
        .pill.info{ background: var(--bl-bg); color: var(--bl-dk); }
        .pill.neu { background: var(--s2); color: var(--m); }

        .bprim {
          display: flex; align-items: center; justify-content: center; gap: 5px;
          padding: 8px 14px; background: var(--pr); color: #fff; border: none;
          border-radius: 5px; font-size: 14px; cursor: pointer; font-family: inherit;
          font-weight: 500; white-space: nowrap; transition: opacity .12s;
        }
        .bprim:hover { opacity: .88; }
        .bprim:disabled { opacity: .5; cursor: not-allowed; }
        .bsec {
          display: flex; align-items: center; gap: 5px; padding: 7px 12px;
          background: var(--s); color: var(--m); border: 0.5px solid var(--b2);
          border-radius: 5px; font-size: 14px; cursor: pointer; font-family: inherit;
          transition: all .12s; white-space: nowrap;
        }
        .bsec:hover { background: var(--s2); color: var(--t); }
        .bdanger { color: var(--rd, #dc3545); border-color: var(--rd, #dc3545); }

        .fg { display: flex; flex-direction: column; gap: 3px; margin-bottom: 10px; }
        .fg label { font-size: 14px; color: var(--m); font-weight: 500; }
        .fg input, .fg select { padding: 9px 13px; border: 0.5px solid var(--b2);
          border-radius: 5px; font-size: 15px; background: var(--s); color: var(--t);
          font-family: inherit; width: 100%; }

        .radio-row { display: flex; gap: 14px; margin-bottom: 10px; }
        .radio-row label { display: flex; align-items: center; gap: 6px; font-size: 14px; color: var(--t); cursor: pointer; }

        .factions { display: flex; gap: 7px; margin-top: 14px; justify-content: flex-end; }

        .modal-overlay {
          position: fixed; inset: 0; background: rgba(0,0,0,0.35); z-index: 200;
          display: flex; align-items: center; justify-content: center; padding: 16px;
        }
        .modal-box {
          background: var(--s); border-radius: var(--radius-lg); border: 0.5px solid var(--b);
          padding: 18px; max-width: 100%; max-height: 90vh; overflow-y: auto;
        }
        .modal-title {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 17px;
          font-weight: 600; color: var(--t); margin-bottom: 13px;
          display: flex; align-items: center; justify-content: space-between;
        }

        .offer-pick {
          display: flex; justify-content: space-between; align-items: center; gap: 10px;
          border: 0.5px solid var(--b2); border-radius: 6px; padding: 10px 12px;
          margin-bottom: 8px; cursor: pointer; transition: all .12s;
        }
        .offer-pick:hover { background: var(--s2); }
        .offer-pick.selected { border-color: var(--pr); background: var(--bl-bg, rgba(0,0,0,0.03)); }

        /* ── TABLEAUX ───
           table-layout: fixed + largeurs explicites sur le thead pour que
           chaque colonne garde une part d'espace garantie. Les colonnes à
           texte variable (Élève, Parent, Offre...) passent à la ligne
           (white-space: normal) au lieu d'être tronquées ; les colonnes
           courtes (dates, statut...) restent sur une seule ligne via .nowrap. */
        .tbl { width: 100%; border-collapse: collapse; font-size: 14px; table-layout: fixed; }
        .tbl th { text-align: left; padding: 9px 10px; color: var(--m); font-weight: 600;
          border-bottom: 0.5px solid var(--b); font-size: 13px; white-space: nowrap;
          overflow: hidden; text-overflow: ellipsis; }
        .tbl td { padding: 10px 10px; border-bottom: 0.5px solid var(--b); color: var(--t);
          vertical-align: top; white-space: normal; word-break: break-word; }
        .tbl td.nowrap { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .tbl tr:last-child td { border-bottom: none; }
        .row-actions { display: flex; gap: 6px; flex-wrap: wrap; }

        /* ── Finances ─────────────────────────────────────── */
        .stats-grid {
          display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 12px; margin-bottom: 16px;
        }
        .stat-card {
          background: var(--s); border: 0.5px solid var(--b); border-radius: var(--radius-md);
          padding: 14px 16px; display: flex; flex-direction: column; gap: 4px;
        }
        .stat-card .stat-label {
          font-size: 12px; color: var(--m); font-weight: 600; display: flex; align-items: center; gap: 5px;
        }
        .stat-card .stat-value { font-size: 22px; font-weight: 700; color: var(--t); }
        .stat-card.accent .stat-value { color: var(--pr); }

        .bars-wrap { display: flex; flex-direction: column; gap: 10px; }
        .bar-row { display: grid; grid-template-columns: 110px 1fr 110px; align-items: center; gap: 10px; }
        .bar-row .bar-label { font-size: 13px; color: var(--m); text-transform: capitalize; white-space: nowrap; }
        .bar-track { background: var(--s2); border-radius: 5px; height: 18px; overflow: hidden; }
        .bar-fill { height: 100%; background: var(--pr); border-radius: 5px; transition: width .3s ease; }
        .bar-row .bar-value { font-size: 13px; color: var(--t); font-weight: 600; text-align: right; white-space: nowrap; }

        .section-title { font-size: 15px; font-weight: 600; color: var(--t); margin: 18px 0 10px; }
      `}</style>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════
// Modale : attribuer une offre à un élève
// ═══════════════════════════════════════════════════════════════════════
function AssignerOffreModal({ eleve, offres, onClose, onConfirm, working }) {
  const [offreId, setOffreId] = useState(null);
  const offresActives = offres.filter(o => o.actif !== false);

  return (
    <Modal title={`Attribuer une offre — ${eleve.prenom} ${eleve.nom}`} onClose={onClose} maxWidth={500}>
      <div style={{ fontSize: 13, color: "var(--m)", marginBottom: 10 }}>
        Parent : {eleve.parent_nom || "—"} {eleve.parent_telephone ? `· ${eleve.parent_telephone}` : ""}
      </div>

      {offresActives.map(o => (
        <div
          key={o.id}
          className={`offer-pick ${offreId === o.id ? "selected" : ""}`}
          onClick={() => setOffreId(o.id)}
        >
          <div>
            <div style={{ fontWeight: 600, fontSize: 14 }}>{o.nom}</div>
            <div style={{ fontSize: 12, color: "var(--m)" }}>{formatMoney(o.prix)} / {o.duree_jours}j</div>
          </div>
          <input type="radio" checked={offreId === o.id} onChange={() => setOffreId(o.id)} />
        </div>
      ))}
      {offresActives.length === 0 && (
        <div style={{ textAlign: "center", color: "var(--h)", padding: 16 }}>Aucune offre active disponible</div>
      )}

      <div className="factions">
        <button className="bsec" onClick={onClose} disabled={working}>Annuler</button>
        <button className="bprim" onClick={() => onConfirm(offreId)} disabled={working || !offreId}>
          {working ? "..." : "Attribuer"}
        </button>
      </div>
    </Modal>
  );
}

// ═══════════════════════════════════════════════════════════════════════
// Modale : renouveler un abonnement (même offre prolongée, ou nouvelle offre)
// ═══════════════════════════════════════════════════════════════════════
function RenouvelerModal({ abonnement, offres, onClose, onConfirm, working }) {
  const [mode, setMode] = useState("meme"); // 'meme' | 'autre'
  const [prolongerJours, setProlongerJours] = useState(abonnement.offre?.duree_jours || 30);
  const [nouvelleOffreId, setNouvelleOffreId] = useState(null);
  const offresActives = offres.filter(o => o.actif !== false);

  const handleConfirm = () => {
    if (mode === "meme") {
      onConfirm({ prolonger_jours: prolongerJours });
    } else {
      if (!nouvelleOffreId) return;
      onConfirm({ offre_id: nouvelleOffreId });
    }
  };

  return (
    <Modal title="Renouveler l'abonnement" onClose={onClose} maxWidth={500}>
      <div style={{ fontSize: 15, color: "var(--t)", marginBottom: 4 }}>
        Élève : <strong>{abonnement.eleve}</strong>
      </div>
      <div style={{ fontSize: 13, color: "var(--m)", marginBottom: 12 }}>
        Offre actuelle : {abonnement.offre?.nom} · échéance {formatDate(abonnement.date_fin)}
      </div>

      <div className="radio-row">
        <label>
          <input type="radio" checked={mode === "meme"} onChange={() => setMode("meme")} />
          Prolonger la même offre
        </label>
        <label>
          <input type="radio" checked={mode === "autre"} onChange={() => setMode("autre")} />
          Changer d'offre
        </label>
      </div>

      {mode === "meme" ? (
        <div className="fg">
          <label>Prolonger de (jours)</label>
          <input
            type="number"
            min={1}
            value={prolongerJours}
            onChange={e => setProlongerJours(parseInt(e.target.value, 10) || 1)}
          />
        </div>
      ) : (
        <div>
          {offresActives.map(o => (
            <div
              key={o.id}
              className={`offer-pick ${nouvelleOffreId === o.id ? "selected" : ""}`}
              onClick={() => setNouvelleOffreId(o.id)}
            >
              <div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{o.nom}</div>
                <div style={{ fontSize: 12, color: "var(--m)" }}>{formatMoney(o.prix)} / {o.duree_jours}j</div>
              </div>
              <input type="radio" checked={nouvelleOffreId === o.id} onChange={() => setNouvelleOffreId(o.id)} />
            </div>
          ))}
        </div>
      )}

      <div className="factions">
        <button className="bsec" onClick={onClose} disabled={working}>Annuler</button>
        <button
          className="bprim"
          onClick={handleConfirm}
          disabled={working || (mode === "autre" && !nouvelleOffreId)}
        >
          {working ? "..." : "Confirmer"}
        </button>
      </div>
    </Modal>
  );
}

// ═══════════════════════════════════════════════════════════════════════
// ÉLÈVES — liste + attribution d'offre (eleves-abonnables/)
// ═══════════════════════════════════════════════════════════════════════
function ElevesPanel({ slug }) {
  const { canSee } = usePermissions();
  const peutAttribuer = canSee("abonnements.attribuer");
  const peutRenouveler = canSee("abonnements.renouveler");
  const peutResilier = canSee("abonnements.resilier");

  const [eleves, setEleves] = useState([]);
  const [offres, setOffres] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [statutFiltre, setStatutFiltre] = useState(""); // '' | 'avec' | 'sans'
  const [assignerCible, setAssignerCible] = useState(null);
  const [renouvelerCible, setRenouvelerCible] = useState(null);
  const [working, setWorking] = useState(false);

  const toast = useToastHook();
  const {
    getElevesAbonnables,
    getOffresPubliques,
    assignerOffreEleve,
    renouvelerAbonnement,
    resilierAbonnement,
  } = useAdminService();

  // Les offres ne servent que pour attribuer / renouveler (changer d'offre).
  useEffect(() => {
    if (!peutAttribuer && !peutRenouveler) return;
    getOffresPubliques().then(d => setOffres(d.results || d || [])).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [peutAttribuer, peutRenouveler]);

  useEffect(() => {
    const t = setTimeout(() => load(), 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, search, statutFiltre]);

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (search) params.search = search;
      if (statutFiltre) params.statut = statutFiltre;
      const data = await getElevesAbonnables(slug, params);
      setEleves(data || []);
    } catch (error) {
      toast.error("Impossible de charger les élèves");
    } finally {
      setLoading(false);
    }
  };

  const handleAssigner = async (offreId) => {
    setWorking(true);
    try {
      await assignerOffreEleve(slug, assignerCible.id, offreId);
      toast.success("Offre attribuée avec succès");
      setAssignerCible(null);
      await load();
    } catch (error) {
      const msg = error?.response?.data?.error || error?.response?.data?.eleve_id?.[0] || "Impossible d'attribuer cette offre";
      toast.error(msg);
    } finally {
      setWorking(false);
    }
  };

  const handleRenouveler = async (payload) => {
    setWorking(true);
    try {
      const abo = renouvelerCible.abonnement_actif;
      const res = await renouvelerAbonnement(slug, abo.id, payload);
      toast.success(res.message || "Abonnement renouvelé");
      setRenouvelerCible(null);
      await load();
    } catch (error) {
      toast.error("Impossible de renouveler cet abonnement");
    } finally {
      setWorking(false);
    }
  };

  const handleResilier = async (eleve) => {
    if (!window.confirm(`Résilier l'abonnement de ${eleve.prenom} ${eleve.nom} ?`)) return;
    setWorking(true);
    try {
      await resilierAbonnement(slug, eleve.abonnement_actif.id);
      toast.success("Abonnement résilié");
      await load();
    } catch (error) {
      toast.error("Impossible de résilier cet abonnement");
    } finally {
      setWorking(false);
    }
  };

  return (
    <div>
      <div className="toolbar">
        <input
          type="text"
          placeholder="Rechercher un élève ou un parent..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ minWidth: 220 }}
        />
        <select value={statutFiltre} onChange={e => setStatutFiltre(e.target.value)}>
          <option value="">Tous les élèves</option>
          <option value="avec">Avec abonnement actif</option>
          <option value="sans">Sans abonnement</option>
        </select>
      </div>

      {loading ? <Loader /> : (
        <div className="card" style={{ padding: 0, overflow: "auto" }}>
          <table className="tbl">
            <thead>
              <tr>
                <th style={{ width: 190 }}>Élève</th>
                <th style={{ width: 100 }}>Classe</th>
                <th style={{ width: 170 }}>Parent</th>
                <th style={{ width: 150 }}>Abonnement</th>
                <th style={{ width: 100 }}>Échéance</th>
                <th style={{ width: 220 }}></th>
              </tr>
            </thead>
            <tbody>
              {eleves.map(el => {
                const abo = el.abonnement_actif;
                const nomComplet = `${el.prenom} ${el.nom}`;
                return (
                  <tr key={el.id}>
                    <td style={{ fontWeight: 500 }} title={nomComplet}>
                      {nomComplet} <span style={{ color: "var(--m)", fontWeight: 400 }}>({el.matricule})</span>
                    </td>
                    <td className="nowrap" title={el.classe_nom || "—"}>{el.classe_nom || "—"}</td>
                    <td>
                      {el.parent_nom || "—"}
                      {el.parent_telephone && <div style={{ fontSize: 12, color: "var(--m)" }}>{el.parent_telephone}</div>}
                    </td>
                    <td className="nowrap">
                      {abo ? (
                        <span className={`pill ${abo.est_valide ? "ok" : "rd"}`}>
                          {abo.est_valide ? abo.offre_nom : `${abo.offre_nom} (expiré)`}
                        </span>
                      ) : (
                        <span className="pill neu">Aucun</span>
                      )}
                    </td>
                    <td className="nowrap">{abo ? formatDate(abo.date_fin) : "—"}</td>
                    <td>
                      <div className="row-actions">
                        {abo ? (
                          <>
                            {/* abonnements.renouveler */}
                            {peutRenouveler && (
                              <button className="bsec" onClick={() => setRenouvelerCible(el)}>
                                <i className="ti ti-refresh" /> Renouveler
                              </button>
                            )}
                            {/* abonnements.resilier */}
                            {peutResilier && (
                              <button className="bsec bdanger" onClick={() => handleResilier(el)} disabled={working}>
                                <i className="ti ti-x" /> Résilier
                              </button>
                            )}
                          </>
                        ) : (
                          /* abonnements.attribuer */
                          peutAttribuer && (
                            <button className="bprim" onClick={() => setAssignerCible(el)} disabled={!el.parent_id}>
                              <i className="ti ti-plus" /> Attribuer
                            </button>
                          )
                        )}
                      </div>
                      {peutAttribuer && !el.parent_id && !abo && (
                        <div style={{ fontSize: 11, color: "var(--rd, #dc3545)", marginTop: 3 }}>Pas de compte parent</div>
                      )}
                    </td>
                  </tr>
                );
              })}
              {eleves.length === 0 && (
                <tr><td colSpan="6" style={{ textAlign: "center", color: "var(--h)", padding: 24 }}>
                  Aucun élève trouvé
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {peutAttribuer && assignerCible && (
        <AssignerOffreModal
          eleve={assignerCible}
          offres={offres}
          onClose={() => setAssignerCible(null)}
          onConfirm={handleAssigner}
          working={working}
        />
      )}

      {peutRenouveler && renouvelerCible && renouvelerCible.abonnement_actif && (
        <RenouvelerModal
          abonnement={{
            eleve: `${renouvelerCible.prenom} ${renouvelerCible.nom}`,
            offre: { nom: renouvelerCible.abonnement_actif.offre_nom, duree_jours: null },
            date_fin: renouvelerCible.abonnement_actif.date_fin,
            abonnement_actif: renouvelerCible.abonnement_actif,
          }}
          offres={offres}
          onClose={() => setRenouvelerCible(null)}
          onConfirm={handleRenouveler}
          working={working}
        />
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════
// TOUS LES ABONNEMENTS (actifs / expirés / résiliés) — abonnements/
// ═══════════════════════════════════════════════════════════════════════
function AbonnementsPanel({ slug }) {
  const { canSee } = usePermissions();
  const peutRenouveler = canSee("abonnements.renouveler");
  const peutResilier = canSee("abonnements.resilier");

  const [abonnements, setAbonnements] = useState([]);
  const [offres, setOffres] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtre, setFiltre] = useState("tous"); // tous | actif | expire | resilie
  const [renouvelerCible, setRenouvelerCible] = useState(null);
  const [working, setWorking] = useState(false);

  const toast = useToastHook();
  const {
    getAbonnementsEtablissement,
    getOffresPubliques,
    renouvelerAbonnement,
    resilierAbonnement,
  } = useAdminService();

  // Les offres ne servent qu'au renouvellement (changement d'offre).
  useEffect(() => {
    if (!peutRenouveler) return;
    getOffresPubliques().then(d => setOffres(d.results || d || [])).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [peutRenouveler]);

  useEffect(() => { load(); }, [slug]);

  const load = async () => {
    setLoading(true);
    try {
      const data = await getAbonnementsEtablissement(slug);
      setAbonnements(data || []);
    } catch (error) {
      toast.error("Impossible de charger les abonnements");
    } finally {
      setLoading(false);
    }
  };

  const visibles = abonnements.filter(a => {
    if (filtre === "tous") return true;
    if (filtre === "actif") return a.statut === "actif" && a.is_active;
    if (filtre === "expire") return a.statut === "actif" && !a.is_active;
    if (filtre === "resilie") return a.statut === "resilie";
    return true;
  });

  const handleRenouveler = async (payload) => {
    setWorking(true);
    try {
      const res = await renouvelerAbonnement(slug, renouvelerCible.id, payload);
      toast.success(res.message || "Abonnement renouvelé");
      setRenouvelerCible(null);
      await load();
    } catch (error) {
      toast.error("Impossible de renouveler cet abonnement");
    } finally {
      setWorking(false);
    }
  };

  const handleResilier = async (abonnement) => {
    if (!window.confirm(`Résilier l'abonnement de ${abonnement.eleve} ?`)) return;
    setWorking(true);
    try {
      await resilierAbonnement(slug, abonnement.id);
      toast.success("Abonnement résilié");
      await load();
    } catch (error) {
      toast.error("Impossible de résilier cet abonnement");
    } finally {
      setWorking(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <div>
      <div className="toolbar">
        {[
          ["tous", "Tous"],
          ["actif", "Actifs"],
          ["expire", "Expirés"],
          ["resilie", "Résiliés"],
        ].map(([val, label]) => (
          <button
            key={val}
            className={filtre === val ? "bprim" : "bsec"}
            onClick={() => setFiltre(val)}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="card" style={{ padding: 0, overflow: "auto" }}>
        <table className="tbl">
          <thead>
            <tr>
              <th style={{ width: 170 }}>Élève</th>
              <th style={{ width: 150 }}>Parent</th>
              <th style={{ width: 150 }}>Offre</th>
              <th style={{ width: 90 }}>Du</th>
              <th style={{ width: 90 }}>Au</th>
              <th style={{ width: 90 }}>Statut</th>
              <th style={{ width: 210 }}></th>
            </tr>
          </thead>
          <tbody>
            {visibles.map(a => {
              const expire = a.statut === "actif" && !a.is_active;
              return (
                <tr key={a.id}>
                  <td style={{ fontWeight: 500 }} title={a.eleve}>{a.eleve}</td>
                  <td title={a.parent || "—"}>{a.parent || "—"}</td>
                  <td title={a.offre?.nom}>{a.offre?.nom}</td>
                  <td className="nowrap">{formatDate(a.date_debut)}</td>
                  <td className="nowrap">{formatDate(a.date_fin)}</td>
                  <td className="nowrap">
                    {a.statut === "resilie" ? (
                      <span className="pill rd">Résilié</span>
                    ) : expire ? (
                      <span className="pill warn">Expiré</span>
                    ) : (
                      <span className="pill ok">Actif</span>
                    )}
                  </td>
                  <td>
                    {a.statut !== "resilie" && (peutRenouveler || peutResilier) && (
                      <div className="row-actions">
                        {/* abonnements.renouveler */}
                        {peutRenouveler && (
                          <button className="bsec" onClick={() => setRenouvelerCible(a)}>
                            <i className="ti ti-refresh" /> Renouveler
                          </button>
                        )}
                        {/* abonnements.resilier */}
                        {peutResilier && (
                          <button className="bsec bdanger" onClick={() => handleResilier(a)} disabled={working}>
                            <i className="ti ti-x" /> Résilier
                          </button>
                        )}
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
            {visibles.length === 0 && (
              <tr><td colSpan="7" style={{ textAlign: "center", color: "var(--h)", padding: 24 }}>
                Aucun abonnement dans cette catégorie
              </td></tr>
            )}
          </tbody>
        </table>
      </div>

      {peutRenouveler && renouvelerCible && (
        <RenouvelerModal
          abonnement={renouvelerCible}
          offres={offres}
          onClose={() => setRenouvelerCible(null)}
          onConfirm={handleRenouveler}
          working={working}
        />
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════
// HISTORIQUE DES PAIEMENTS — historique-abonnements/
// ═══════════════════════════════════════════════════════════════════════
function HistoriquePaiementsPanel({ slug }) {
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [data, setData] = useState({ historique_paiements: [], statistiques: {} });
  const [loading, setLoading] = useState(true);

  const toast = useToastHook();
  const { getHistoriqueAbonnements } = useAdminService();

  useEffect(() => { load(); }, [slug, dateDebut, dateFin]);

  const load = async () => {
    setLoading(true);
    try {
      const res = await getHistoriqueAbonnements(slug, { date_debut: dateDebut, date_fin: dateFin });
      setData(res);
    } catch (error) {
      toast.error("Impossible de charger l'historique des paiements");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  const { historique_paiements: rows = [], statistiques = {} } = data;

  return (
    <div>
      <div className="toolbar">
        <input type="date" value={dateDebut} onChange={e => setDateDebut(e.target.value)} title="Du" />
        <input type="date" value={dateFin} onChange={e => setDateFin(e.target.value)} title="Au" />
        <span className="pill info">
          {statistiques.total_paiements ?? 0} paiement(s) — {formatMoney(statistiques.montant_total)}
        </span>
      </div>

      <div className="card" style={{ padding: 0, overflow: "auto" }}>
        <table className="tbl">
          <thead>
            <tr>
              <th style={{ width: 180 }}>Élève</th>
              <th style={{ width: 170 }}>Parent</th>
              <th style={{ width: 160 }}>Offre</th>
              <th style={{ width: 110 }}>Montant</th>
              <th style={{ width: 100 }}>Date</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(h => (
              <tr key={h.id}>
                <td style={{ fontWeight: 500 }} title={h.eleve_nom}>{h.eleve_nom}</td>
                <td title={h.parent_nom}>{h.parent_nom}</td>
                <td title={h.offre_nom}>{h.offre_nom}</td>
                <td className="nowrap">{formatMoney(h.prix)}</td>
                <td className="nowrap">{formatDate(h.date_renouvellement)}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan="5" style={{ textAlign: "center", color: "var(--h)", padding: 24 }}>
                Aucun paiement enregistré
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════
// FINANCES — statistiques de chiffre d'affaires (finances-abonnements/)
// ═══════════════════════════════════════════════════════════════════════
function FinancesPanel({ slug }) {
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [data, setData] = useState({ resume: {}, revenu_par_offre: [], revenu_par_mois: [] });
  const [loading, setLoading] = useState(true);

  const toast = useToastHook();
  const { getFinancesAbonnements } = useAdminService();

  useEffect(() => { load(); }, [slug, dateDebut, dateFin]);

  const load = async () => {
    setLoading(true);
    try {
      const res = await getFinancesAbonnements(slug, { date_debut: dateDebut, date_fin: dateFin });
      setData(res);
    } catch (error) {
      toast.error("Impossible de charger les statistiques financières");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  const { resume = {}, revenu_par_offre: parOffre = [], revenu_par_mois: parMois = [] } = data;
  const maxOffre = Math.max(1, ...parOffre.map(o => o.montant));
  const maxMois = Math.max(1, ...parMois.map(m => m.montant));

  return (
    <div>
      <div className="toolbar">
        <input type="date" value={dateDebut} onChange={e => setDateDebut(e.target.value)} title="Du" />
        <input type="date" value={dateFin} onChange={e => setDateFin(e.target.value)} title="Au" />
      </div>

      <div className="stats-grid">
        <div className="stat-card accent">
          <div className="stat-label"><i className="ti ti-cash" /> Chiffre d'affaires</div>
          <div className="stat-value">{formatMoney(resume.montant_total)}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label"><i className="ti ti-receipt" /> Paiements</div>
          <div className="stat-value">{resume.nombre_paiements ?? 0}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label"><i className="ti ti-calculator" /> Panier moyen</div>
          <div className="stat-value">{formatMoney(resume.montant_moyen)}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label"><i className="ti ti-repeat" /> Revenu récurrent estimé</div>
          <div className="stat-value">{formatMoney(resume.revenu_recurrent_estime)}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label"><i className="ti ti-circle-check" /> Abonnements actifs</div>
          <div className="stat-value">{resume.abonnements_actifs ?? 0}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label"><i className="ti ti-alert-triangle" /> Expirés</div>
          <div className="stat-value">{resume.abonnements_expires ?? 0}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label"><i className="ti ti-x" /> Résiliés</div>
          <div className="stat-value">{resume.abonnements_resilies ?? 0}</div>
        </div>
      </div>

      <div className="section-title">Revenu par offre</div>
      <div className="card">
        {parOffre.length === 0 ? (
          <div style={{ textAlign: "center", color: "var(--h)", padding: 16 }}>Aucune donnée</div>
        ) : (
          <div className="bars-wrap">
            {parOffre.map(o => (
              <div className="bar-row" key={o.offre_id}>
                <span className="bar-label">{o.offre_nom}</span>
                <div className="bar-track">
                  <div className="bar-fill" style={{ width: `${(o.montant / maxOffre) * 100}%` }} />
                </div>
                <span className="bar-value">{formatMoney(o.montant)} · {o.nombre}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="section-title">Revenu par mois</div>
      <div className="card">
        {parMois.length === 0 ? (
          <div style={{ textAlign: "center", color: "var(--h)", padding: 16 }}>Aucune donnée</div>
        ) : (
          <div className="bars-wrap">
            {parMois.map(m => (
              <div className="bar-row" key={m.mois}>
                <span className="bar-label">{formatMois(m.mois)}</span>
                <div className="bar-track">
                  <div className="bar-fill" style={{ width: `${(m.montant / maxMois) * 100}%` }} />
                </div>
                <span className="bar-value">{formatMoney(m.montant)} · {m.nombre}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}